export default __webpack_public_path__ + "static/media/Clan Bound Helm of the Seven Suns.878fdcae.jpg";